// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"418":"0e64215efbff401752df","661":"6c1cfebb30135fed8034"}[chunkId] + ".js";
};